import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
  VirtualTableSortableColumnDirectionsEnum,
} from '../../../../../../../../../src/components/common/table/helpers/tableHelpers';
import {
  SortableTableColumn,
  TableColumn,
} from '../../../../../../../../../src/components/common/table/tableColumn';
import {VisualSizesEnum} from '../../../../../../../../shared/ui/src/styles/commonStyles';
import {ColumnWidthsEnum, SharedColumnsEnum} from '../sharedTableConfig';

/*
 * Constants.
 */

const contactsTableNameColumnId = 'contact-name';

export enum ContactsTableDefaultColumnsEnum {
  NAME = 'name',
  EMAIL = 'email',
  TWITTER = 'twitter',
  PHONE = 'phone',
  ACCOUNT = 'account',
  DESCRIPTION = 'description',
  LISTS = 'lists',
}

export type ContactsTableColumnsEnum = ContactsTableDefaultColumnsEnum | SharedColumnsEnum;

export const contactsTableColumns: ReadonlyArray<TableColumn<ContactsTableColumnsEnum>> = [
  {
    id: contactsTableNameColumnId,
    title: <Trans id="contact-manager-table-col-name">Name</Trans>,
    type: ContactsTableDefaultColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.CARD,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: ColumnWidthsEnum.LARGE,
        maxWidth: ColumnWidthsEnum.LARGE,
      },
      loading: {
        avatarSize: VisualSizesEnum.LARGE,
      },
    },
  },
  {
    id: 'contact-account',
    title: <Trans id="contact-manager-table-col-account">Account</Trans>,
    type: ContactsTableDefaultColumnsEnum.ACCOUNT,
    cellType: VirtualTableColumnCellsEnum.AVATAR,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    id: 'contact-email',
    title: <Trans id="contact-manager-table-col-email">Email</Trans>,
    type: ContactsTableDefaultColumnsEnum.EMAIL,
    cellType: VirtualTableColumnCellsEnum.HANDLE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.LARGE,
      },
    },
  },
  {
    id: 'contact-phone',
    title: <Trans id="contact-manager-table-col-phone">Phone Number</Trans>,
    type: ContactsTableDefaultColumnsEnum.PHONE,
    cellType: VirtualTableColumnCellsEnum.HANDLE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.SMALL,
      },
    },
  },
  {
    id: 'contact-twitter',
    title: <Trans id="contact-manager-table-col-twitter">Twitter</Trans>,
    type: ContactsTableDefaultColumnsEnum.TWITTER,
    cellType: VirtualTableColumnCellsEnum.HANDLE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.SMALL,
      },
    },
  },
  {
    id: 'contact-description',
    title: <Trans id="contact-description">Description</Trans>,
    type: ContactsTableDefaultColumnsEnum.DESCRIPTION,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    id: 'contact-lists',
    title: <Trans id="contact-lists">Lists</Trans>,
    type: ContactsTableDefaultColumnsEnum.LISTS,
    cellType: VirtualTableColumnCellsEnum.CARD_GROUP,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
];

export const companyContactsTableSortableColumns: ReadonlyArray<SortableTableColumn> = [
  {
    id: contactsTableNameColumnId,
    directions: [
      VirtualTableSortableColumnDirectionsEnum.ASCENDING,
      VirtualTableSortableColumnDirectionsEnum.DESCENDING,
    ],
  },
];
